import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=4d8f1904&scoped=true&"
var script = {}
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=4d8f1904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f1904",
  null
  
)

export default component.exports